export async function refreshBatchDetailsAfterSamplePrint({
  fetchBatch,
  updateSamplesList,
  clearSelection,
}) {
  await Promise.all([fetchBatch(), updateSamplesList()])
  clearSelection()
}
